var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelTiktokFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(3 3)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "#000",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M14.858 7.773q-.157.016-.317.016a3.43 3.43 0 0 1-2.871-1.552v5.285a3.906 3.906 0 1 1-3.907-3.906c.082 0 .162.007.242.012v1.925c-.08-.01-.16-.024-.242-.024a1.994 1.994 0 1 0 0 3.987c1.102 0 2.074-.867 2.074-1.968l.02-8.977h1.841a3.43 3.43 0 0 0 3.161 3.063v2.14"
}))));
export default SvgGemChannelTiktokFilled;